import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    ...async('CREATE_SELF_RENT'),
    ...async('SAVE_DATES_AND_TIME_SLOTS_FOR_RENT'),
    ...async('MODIFY_AND_CONFIRM_RENT'),
    ...async('CREATE_RETURN_TRANSACTION'),
    ...async('SAVE_DATES_AND_TIME_SLOTS_FOR_RETURN'),
    ...async('MODIFY_AND_CONFIRM_RETURN'),
    'SET_WILL_RETURN_ITEMS',
    'ADD_ITEM',
    'REMOVE_ITEM',
  ],
  'REMOVE/START',
)



// WEBPACK FOOTER //
// ./src/sections/remove/types/start.js